import { render, staticRenderFns } from "./AddContact.vue?vue&type=template&id=bdff2ada&scoped=true"
import script from "./AddContact.vue?vue&type=script&lang=js"
export * from "./AddContact.vue?vue&type=script&lang=js"
import style0 from "./AddContact.vue?vue&type=style&index=0&id=bdff2ada&prod&scoped=true&lang=css"
import style1 from "./AddContact.vue?vue&type=style&index=1&id=bdff2ada&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdff2ada",
  null
  
)

export default component.exports